export default __webpack_public_path__ + "static/title-gallery-en-83993536a8a671ade4625928d850f4e1.png";